// extracted by mini-css-extract-plugin
module.exports = {"primary-button":"buttons_primary-button__9MrpB","normal-button":"buttons_normal-button__3IRp7"};